<template>
    <div class="copy-element">
        <CompassLink
            :label="linkLabel"
            :link="url"
            :type="color"
            :target="blank ? '_blank' : '_self'"
        />
        <SaasClipboard v-if="linkLabel" :data="linkLabel" />
    </div>
</template>
<script>
import SaasClipboard from 'vcomponents/utilities/SaasClipboard.vue';
export default {
    components: {
        SaasClipboard,
    },
    props: {
        color: {
            type: String,
            default: 'primary',
        },
        url: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        blank: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        linkLabel() {
            return this.label !== '' ? this.label : this.url;
        },
    },
};
</script>
<style lang="scss" scoped>
.copy-element {
    display: inline-block;
    max-width: 100%;

    &::v-deep {
        a {
            max-width: calc(100% - 28px);

            span {
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}
</style>
